'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './appconfgroups.routes';
import list from './list';
import edit from './edit';
import add from './add';
import show from './show';
import addmodel from './addmodel';

export default angular.module('updateServerApp.appconfgroups', [uiRouter, list, edit, add, show, addmodel])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/index.js